import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  container: size => ({
    width: size,
    height: size,
    borderRadius: size / 2,
    alignItems: 'center',
    justifyContent: 'center',
  }),
  animateContainer: (size, color, ransformAnimator, opacityAnimator) => ({
    width: size,
    height: size,
    borderRadius: size / 2,
    position: 'absolute',
    left: 0,
    top: 0,
    backgroundColor: color,
    opacity: opacityAnimator,
    transform: [{scale: ransformAnimator}],
  }),
  iconContainer: (iconSize, color) => ({
    width: iconSize + 16,
    height: iconSize + 16,
    borderRadius: (iconSize + 16) / 2,
    backgroundColor: color,
    alignItems: 'center',
    justifyContent: 'center',
  }),
  iconImage: iconSize => ({
    height: iconSize,
    width: iconSize,
  }),
});
